<template>
  <div>
    <div class="d-flex mb-2">
      <TextField
        v-model="department.name"
        label="Name"
        name="name"
        placeholder="Department Name"
        :validation-errors="v$.$errors"
        labelClass="flex-1"
      />
    </div>
    <div class="d-flex mb-3">
      <Select
        v-model="department.timezone"
        name="Timezone"
        label="Timezone"
        placeholder="Select TimeZone"
        :options="timezones"
        :field-error="firstErrorMessage(v$.department?.timezone)"
        class="half-width mr-3"
      />
      <TextField
        v-if="department && department.integrations.pulse_m.enabled"
        v-model="department.integrations.pulse_m.location_id"
        label="PulseM Location ID"
        name="location_id"
        :validation-errors="v$.$errors"
        labelClass="flex-1"
      />
    </div>
    <div class="d-flex mb-2">
      <TextField
        v-model="department.labor_hourly_cost_cents"
        currency
        label="Hourly Labor Cost"
        name="labor_hourly_cost_cents"
        placeholder="$0.0"
        labelClass="flex-1 mr-3"
      />
      <TextField
        v-model="department.default_billing_terms"
        label="Default Billing Terms"
        name="default_billing_terms"
        labelClass="flex-1"
      />
    </div>
    <div class="d-flex gap-3">
      <Select
        v-if="showAccountingCategories"
        v-model="department.default_accounting_category_id"
        name="Default Accounting Category"
        placeholder="Default Accounting Category"
        label="Default Accounting Category"
        :options="accountingCategoriesOptions"
        class="flex-1 mr-3"
      />
      <Select
        v-if="showAccountingClasses"
        v-model="department.accounting_class_id"
        name="Default Accounting Class"
        placeholder="Default Accounting Class"
        :options="accountingClassOptions"
        label="Default Accounting Class"
        :field-error="firstErrorMessage(v$.department?.accounting_class_id)"
        class="flex-1"
      >
        <template #item-row="{ option }">
          <div class="option-row">
            <span :class="{ 'strike-through': option.archived }">
              {{ option.label }}
            </span>
          </div>
        </template>
      </Select>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { firstErrorMessage } from "@/lib/vuelidate_helpers";

import TextField from "@/components/TextField.vue";
import useVuelidate from "@vuelidate/core";
import { helpers, required } from "@vuelidate/validators";
export default {
  components: {
    TextField
  },
  setup() {
    return {
      v$: useVuelidate()
    };
  },
  data() {
    return {
      department: { integrations: { pulse_m: {} } }
    };
  },
  computed: {
    ...mapGetters([
      "accountingClassOptions",
      "showAccountingCategories",
      "showAccountingClasses"
    ]),
    ...mapState({
      timezones: "timezones",
      currentDepartment: "currentDepartment",
      accountingCategories: "accountingCategories",
      accountingCategoriesOptions: ({ accountingCategories }) =>
        accountingCategories.map((accountingCategory) => ({
          value: accountingCategory.id,
          label: accountingCategory.name
        }))
    })
  },
  watch: {
    currentDepartment(newValue, oldValue) {
      if (newValue !== oldValue && newValue) {
        this.department = {
          ...this.currentDepartment
        };
      }
    }
  },
  validations() {
    return {
      department: {
        name: {
          required: helpers.withMessage("Name required", required),
          $autoDirty: true
        },
        timezone: {
          required: helpers.withMessage("Timezone required", required),
          $autoDirty: true
        }
      }
    };
  },
  methods: {
    getDataToSave() {
      return this.v$.$validate().then((valid) => {
        if (!valid)
          return Promise.reject(
            new Error("Department fields validation failed")
          );
        return this.department;
      });
    },
    firstErrorMessage
  }
};
</script>

<style lang="scss" scoped>
.half-width {
  width: 49% !important;
}
</style>
